import { useEffect, useRef, useState } from 'react';
import { Card } from '../../../layout/Card.jsx';
import { Icon } from '../../../layout/Icon.jsx';
import { EventRow } from './EventRow.jsx';

export function EventFeed({ events, loading }) {
  const [autoScroll, setAutoScroll] = useState(true);
  const scrollRef = useRef(null);

  useEffect(() => {
    if (autoScroll && scrollRef.current) {
      scrollRef.current.scrollTop = 0;
    }
  }, [events, autoScroll]);

  return (
    <Card
      header={
        <div className="flex items-center gap-2 w-full">
          <span>سجل الأحداث</span>
          <span className="text-xs text-ink-3">({events.length})</span>
          <div className="flex-1" />
          <span className="flex items-center gap-1.5 text-[11px]">
            <span className="live-dot" /> حي
          </span>
          <button
            type="button"
            className="btn btn-ghost text-[11.5px]"
            onClick={() => setAutoScroll((v) => !v)}
            style={{ padding: '2px 6px' }}
          >
            {autoScroll ? 'إيقاف التمرير التلقائي' : 'تشغيل التمرير'}
          </button>
        </div>
      }
    >
      <div ref={scrollRef} className="overflow-auto" style={{ maxHeight: 480 }}>
        {loading ? (
          <div className="text-center py-8 text-ink-3">جاري التحميل...</div>
        ) : events.length === 0 ? (
          <div className="text-center py-8 text-ink-3 flex flex-col items-center gap-2">
            <Icon name="gate" size={36} color="#D6CCB3" />
            <span>لا توجد قراءات بعد</span>
          </div>
        ) : (
          <table className="w-full">
            <thead className="text-[11.5px] text-ink-2">
              <tr className="border-b border-line">
                <th className="p-2 text-start">الوقت</th>
                <th className="p-2 text-start">البوابة</th>
                <th className="p-2 text-start">الكارت</th>
                <th className="p-2 text-start">الطفل</th>
                <th className="p-2 text-start">الحالة</th>
                <th className="p-2 text-start">السبب</th>
              </tr>
            </thead>
            <tbody>
              {events.map((e, i) => (
                <EventRow key={e._id || e.id || `${e.cardUid}-${i}`} event={e} isFirst={i === 0} />
              ))}
            </tbody>
          </table>
        )}
      </div>
      <style>{`@keyframes gateFadeIn { from { background:#FFF6EB; } to { background:transparent; } }`}</style>
    </Card>
  );
}
